/**
 * Email validation regex pattern
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * More comprehensive email regex (RFC 5322 compliant)
 */
export const EMAIL_REGEX_STRICT = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

/**
 * Check if a string is a valid email address
 * @param {string} email - The email to validate
 * @returns {boolean} True if valid email
 */
export function isValidEmail(email) {
  return EMAIL_REGEX.test(email)
}

/**
 * Check if a string is a valid email address (strict mode)
 * @param {string} email - The email to validate
 * @returns {boolean} True if valid email
 */
export function isValidEmailStrict(email) {
  return EMAIL_REGEX_STRICT.test(email)
}

/**
 * Check if a string is not empty after trimming
 * @param {string} value - The value to check
 * @returns {boolean} True if not empty
 */
export function isNotEmpty(value) {
  return value && value.trim().length > 0
}
